import { ThemeMode } from "../../../types";

import type { ThemeColors } from "../../../types";

export const yellow = {
  [ThemeMode.LIGHT]: {
    background: [1, 0, 0],
    foreground: [0.141, 0.005, 285.823],
    card: [1, 0, 0],
    "card-foreground": [0.141, 0.005, 285.823],
    popover: [1, 0, 0],
    "popover-foreground": [0.141, 0.005, 285.823],
    primary: [0.795, 0.184, 86.047],
    "primary-foreground": [0.421, 0.095, 57.708],
    secondary: [0.967, 0.001, 286.375],
    "secondary-foreground": [0.21, 0.006, 285.885],
    muted: [0.967, 0.001, 286.375],
    "muted-foreground": [0.552, 0.016, 285.938],
    accent: [0.967, 0.001, 286.375],
    "accent-foreground": [0.21, 0.006, 285.885],
    destructive: [0.577, 0.245, 27.325],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.7999, 0.1816, 151.78],
    "success-foreground": [0.9848, 0, 0],
    border: [0.92, 0.004, 286.32],
    input: [0.92, 0.004, 286.32],
    ring: [0.795, 0.184, 86.047],
    "chart-1": [0.905, 0.182, 98.111],
    "chart-2": [0.795, 0.184, 86.047],
    "chart-3": [0.681, 0.162, 75.834],
    "chart-4": [0.554, 0.135, 66.442],
    "chart-5": [0.476, 0.114, 61.907],
    sidebar: [0.985, 0, 0],
    "sidebar-foreground": [0.141, 0.005, 285.823],
    "sidebar-primary": [0.795, 0.184, 86.047],
    "sidebar-primary-foreground": [0.421, 0.095, 57.708],
    "sidebar-accent": [0.967, 0.001, 286.375],
    "sidebar-accent-foreground": [0.21, 0.006, 285.885],
    "sidebar-border": [0.92, 0.004, 286.32],
    "sidebar-ring": [0.795, 0.184, 86.047],
  },
  [ThemeMode.DARK]: {
    background: [0.141, 0.005, 285.823],
    foreground: [0.985, 0, 0],
    card: [0.21, 0.006, 285.885],
    "card-foreground": [0.985, 0, 0],
    popover: [0.21, 0.006, 285.885],
    "popover-foreground": [0.985, 0, 0],
    primary: [0.795, 0.184, 86.047],
    "primary-foreground": [0.421, 0.095, 57.708],
    secondary: [0.274, 0.006, 286.033],
    "secondary-foreground": [0.985, 0, 0],
    muted: [0.274, 0.006, 286.033],
    "muted-foreground": [0.705, 0.015, 286.067],
    accent: [0.274, 0.006, 286.033],
    "accent-foreground": [0.985, 0, 0],
    destructive: [0.704, 0.191, 22.216],
    "destructive-foreground": [0.985, 0.002, 247.839],
    success: [0.627, 0.194, 149.214],
    "success-foreground": [0.985, 0, 0],
    border: [1, 0, 0, 0.1],
    input: [1, 0, 0, 0.15],
    ring: [0.554, 0.135, 66.442],
    "chart-1": [0.905, 0.182, 98.111],
    "chart-2": [0.795, 0.184, 86.047],
    "chart-3": [0.681, 0.162, 75.834],
    "chart-4": [0.554, 0.135, 66.442],
    "chart-5": [0.476, 0.114, 61.907],
    sidebar: [0.21, 0.006, 285.885],
    "sidebar-foreground": [0.985, 0, 0],
    "sidebar-primary": [0.795, 0.184, 86.047],
    "sidebar-primary-foreground": [0.421, 0.095, 57.708],
    "sidebar-accent": [0.274, 0.006, 286.033],
    "sidebar-accent-foreground": [0.985, 0, 0],
    "sidebar-border": [1, 0, 0, 0.1],
    "sidebar-ring": [0.554, 0.135, 66.442],
  },
} satisfies ThemeColors;
